module.exports = __webpack_public_path__ + "static/logo-56823e99429447df131863acdc06080a.svg";